<div *ngIf="hidden==false" class="ui_notification" [class.ui_black]="type==1" [class.ui_green]="type==4" [class.ui_red]="type==3" [class.ui_yellow]="type==2" style="z-index: 10050;position: fixed;right: 5px;top: 5px;background-color: white; " >
  <!--h6>{{getMessageType()}}</h6-->
  <div class="ui_notification_box">
    <a class="ui_close" href="javascript:void(0)" (click)="close()"></a>
    <img [src]="getImage()" style="width: 25px;" >
    <strong>{{messageTitle}}</strong>
    <p *ngIf="message!=null">{{message}}</p>
    <p *ngIf="messagehtml!=null" [innerHTML]="messagehtml">&nbsp;</p>
  </div>
</div>